import _Overlay from "@kibt/meta-ui/es/overlay";
import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { defineComponent } from '@vue/composition-api';
import dayjs from 'dayjs';
import useStore from '../store';
export default defineComponent({
  components: {
    MOverlay: _Overlay
  },
  setup: function setup(props, ctx) {
    var store = useStore();

    var formateTime = function formateTime(time) {
      return dayjs(time).format('DD/MM HH:mm');
    };

    var isFetching = false;

    var handleToAppointment = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isFetching) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                isFetching = true;

                if (!store.activeVenue) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return store.toAppointment(store.activeVenue.venueId);

              case 6:
                isFetching = false;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleToAppointment() {
        return _ref.apply(this, arguments);
      };
    }();

    return {
      store: store,
      formateTime: formateTime,
      handleToAppointment: handleToAppointment
    };
  }
});